<template>
  <v-form>
    <v-select v-model="activeClient"
              :items="$store.getters.appClients"
              :item-value="item => item"
              :item-text="item => item.name"
              :hide-selected="true"
              @change="onChange"
              demse
              label="Выберите активного клиента"
              append-outer-icon="mdi-refresh"
              @click:append-outer="onRefreshCountButtonClicked"
    >
      <template v-slot:item="{item, on}">
        <v-list-item v-on="on">
          <v-list-item-title>
            {{ item.name }}
            <span class="float-right font-weight-bold">{{ getCount(item) }}</span>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-select>
    <template>
      <v-card
          class="mx-auto"
          tile
          v-for="client in $store.getters.appClients"
          :key="client.id"
      >
        <v-list-item v-if="getCount(client) > 0">
          <v-list-item-content>
            <v-list-item-title class="text-left">
              {{ client.name }}
              <span class="float-right font-weight-bold">{{ getCount(client) }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </template>
  </v-form>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import {APP_CHANGE_CLIENT} from "@/store/modules/app/actions";
import MailService from '@/services/mail.service'
import _ from 'underscore'
import Mapper from '@/mappers'

export default {
  name: "ActiveClient",
  data() {
    return {
      activeClient: null,
      clientNotPrintedMailsCounts: []
    }
  },
  methods: {
    loadCounts() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      MailService.getNotPrintedCountsByClient()
          .then(response => {
            this.clientNotPrintedMailsCounts = _.map(response.data, r => {
              return {
                client: Mapper.mapClient(r.Client),
                count: r.Count
              }
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },

    onChange() {
      this.$store.dispatch(APP_CHANGE_CLIENT, this.activeClient)
    },
    onRefreshCountButtonClicked() {
      this.loadCounts()
    },
    getCount(client) {
      let c = _.find(this.clientNotPrintedMailsCounts, x => {
        return x.client === client
      })
      if (c)
        return c.count
      return 0
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Главная страница')
    this.activeClient = this.$store.getters.appActiveClient

    this.loadCounts()
  }
}
</script>
